const AVAILABLE_COUNTRIES = {
  ARE: 'الإمارات العربية المتحدة',
  ARG: 'Argentina',
  AUS: 'Australia',
  AUT: 'Österreich',
  BEL: 'België',
  BGD: 'বাংলাদেশ',
  BRA: 'Brasil',
  CAN: 'Canada',
  CHE: 'Schweiz',
  CHL: 'Chile',
  CHN: '中国',
  COL: 'Colombia',
  CYP: 'Κύπρος',
  CZE: 'Česká republika',
  DEU: 'Deutschland',
  DNK: 'Danmark',
  DZA: 'الجزائر',
  EGY: 'مصر',
  ESP: 'España',
  EST: 'Eesti',
  FIN: 'Suomi',
  FRA: 'France',
  GBR: 'United Kingdom',
  GRC: 'Ελλάδα',
  HKG: '香港',
  HUN: 'Magyarország',
  IDN: 'Indonesia',
  IND: 'भारत',
  IRL: 'Ireland',
  IRQ: 'العراق',
  ISR: 'ישראל',
  ITA: 'Italia',
  JPN: '日本',
  KAZ: 'Қазақстан',
  KOR: '대한민국',
  KWT: 'الكويت',
  LBN: 'لبنان',
  LKA: 'ශ්‍රී ලංකාව',
  LTU: 'Lietuva',
  LUX: 'Lëtzebuerg',
  LVA: 'Latvija',
  MAR: 'المغرب',
  MEX: 'México',
  MYS: 'Malaysia',
  NGA: 'Nigeria',
  NLD: 'Nederland',
  NOR: 'Norge',
  NZL: 'New Zealand',
  OMN: 'عُمان',
  PAK: 'پاکستان',
  PER: 'Perú',
  PHL: 'Pilipinas',
  POL: 'Polska',
  PRT: 'Portugal',
  QAT: 'قطر',
  ROU: 'România',
  RUS: 'Россия',
  SAU: 'المملكة العربية السعودية',
  SGP: 'Singapore',
  SVK: 'Slovenská republika',
  SVN: 'Slovenija',
  SWE: 'Sverige',
  THA: 'ประเทศไทย',
  TUR: 'Türkiye',
  TWN: '台灣',
  UKR: 'Україна',
  USA: 'United States',
  UZB: 'Oʻzbekiston',
  VNM: 'Việt Nam',
  ZAF: 'South Africa'
};

export default AVAILABLE_COUNTRIES;
